/**
 * S04 — ACT II: THE OWNER (The Uncooked Gems Phase)
 *
 * Full-bleed HF#5 Act II video sequence as hero background, with
 * the payphone still as the poster fallback. Autoplays muted on
 * viewport entry, pauses on exit. Vladimir magenta overlay wash.
 * Mirrors the S03 Act I pattern — uses the shared ActSection primitive.
 */

import { ActSection } from "./ActSection";
import { sectionCopy, actStories } from "@/lib/voice";
import videoSrc from "@/assets/higgsfield/hf-05-act-ii-sequence.mp4";
import posterSrc from "@/assets/higgsfield/hf-05-meyhem-payphone.webp";

export function S04_ActTwo() {
  const copy = sectionCopy.s04;
  return (
    <ActSection
      sectionId="s04"
      meta={copy.meta}
      monument={copy.monument}
      act={actStories.act2}
      videoSrc={videoSrc}
      videoPoster={posterSrc}
      spotColor="vladimir"
      bgFilter="contrast(1.12) brightness(0.55) saturate(0.9)"
      overlayGradient="radial-gradient(ellipse at center, rgba(5,5,5,0.25) 0%, rgba(5,5,5,0.88) 100%)"
    />
  );
}
